import sal from 'sal.js'

document.addEventListener('DOMContentLoaded', () => {
  sal({
    threshold: 0.1
  })
})
